/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var Print = {};

(function ($) {

	Print.process = function () {
		$('.print-btn').on('click keydown', function (e) {
			var etype = e.type;

			if (etype === 'keydown' && ( e.keyCode !== 13 && e.keyCode !== 32 )) {
				return true;
			}

			e.preventDefault();

			var printContents = '';

			$('.printable').each(function () {
				printContents += $(this).html();
			});

			var html = '<html><head>' + document.head.innerHTML + '</head><body onload="window.print(); window.close();">' + printContents + '</body></html>';

			var tab = window.open('', '_blank');
			
			tab.document.write(html);
			tab.document.close();

			tab.focus();

			Print.process();
		});
	};

	$(document).ready(function () {
		Print.process();
	});

})(jQuery);
